import { Designer, Profile, Project } from '@brg/api';
import { IDesignerLight, IProjectLight } from '../../shared/common';

export class bProject {
    /**
     * Возвращает true, если проект можно редактировать
     * @param project
     * @param designer
     */
    public static isEditableFor(
        project: Project | Project<'Global'> | IProjectLight | undefined,
        designer: Designer | Designer<'Global'> | Profile | IDesignerLight | undefined,
    ): boolean {
        if (project && designer)
            return (
                project?.authorId === designer?.accountId ||
                project?.coAuthorIds?.includes(designer?.accountId) ||
                //project.authorIds.includes(designer.accountId) ||
                project?.curatorsIdList?.includes(designer?.accountId)
            );
        return false;
    }
}
import { Designer, Profile, Project } from '@brg/api';
import { IDesignerLight, IProjectLight } from '../../shared/common';

export class bProject {
    /**
     * Возвращает true, если проект можно редактировать
     * @param project
     * @param designer
     */
    public static isEditableFor(
        project: Project | Project<'Global'> | IProjectLight | undefined,
        designer: Designer | Designer<'Global'> | Profile | IDesignerLight | undefined,
    ): boolean {
        if (project && designer)
            return (
                project?.authorId === designer?.accountId ||
                project?.coAuthorIds?.includes(designer?.accountId) ||
                //project.authorIds.includes(designer.accountId) ||
                project?.curatorsIdList?.includes(designer?.accountId)
            );
        return false;
    }
}
